import axios from './axios'
import qs from 'qs';
let baseUrl = '/api/return/';
/**
 *
 * 
 */
export default {
  // 退货管理列表
  list(data) {
    return axios.post(baseUrl + 'listReturnInboundRecord', qs.stringify(data));
  },

  detail(data) {
    return axios.get(baseUrl + 'detailReturnInboundRecord', {
      params: data
    });
  },

  //添加流水
  addOrUpdatePayRecord(data) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return axios.post(baseUrl + 'addOrUpdatePayRecord', data, config);
  },

  // 保存/退货成功
  editPurchaseReturnRecord(data) {
    return axios.post(baseUrl + 'editPurchaseReturnRecord', qs.stringify(data));
  },

  // 新增换货采购
  batchPurchase(data) {
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    if ([null].includes(data)) {
      return;
    }
    return axios.post(baseUrl + 'batchPurchase', data, config);
  },
}
